import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.surface.high};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  padding: 16px;
  flex: 1;
`;

export const DateBadge = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-evenly;
  background: ${({ theme }) => theme.colors.surface.high};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 20px;
  width: 48px;
  height: 140px;
  flex-shrink: 0;
`;

export const DateWeekday = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16.8px;
  text-align: left;
  color: ${({ theme }) => theme.colors.button.text.disabled};
`;

export const DateDivision = styled.div`
  width: 32px;
  height: 1px;
  background-color: ${({ theme }) => theme.colors.surface.low};
`;

export const DateDay = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 24px;
  font-weight: 700;
  line-height: 22.4px;
  text-align: center;
  color: ${({ theme }) => theme.colors.accent.primary};
`;

export const DateMonth = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16.8px;
  text-align: left;
  color: ${({ theme }) => theme.colors.accent.primary};
`;

export const DateTime = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 14px;
  text-align: left;
  color: ${({ theme }) => theme.colors.button.text.disabled};
`;

export const TicketContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
`;

export const TicketHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const TicketInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const TicketName = styled.h3`
  font-family: 'Elza', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 19.36px;
  text-align: left;
  margin: 0;
  padding: 0;
`;

export const TicketPrice = styled.span`
  font-family: 'Elza', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const BuyerInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const Avatar = styled.img`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
`;

export const BuyerDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const BuyerName = styled.p`
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  margin: 0;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const YouBadge = styled.span`
  font-weight: 400;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const BuyerEmail = styled.p`
  font-family: 'Elza', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0;
  color: ${({ theme }) => theme.colors.text.secondary};
`;
